import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from './data.service';
import { SplashScreenService } from './splash-screen.service';
import { map, Observable, of, shareReplay, tap } from 'rxjs';
import { GetOrder, Order, RejectedItem } from '../models/cart.model';
import { MenuClosedResponse } from '../models/menu.model';
import { Transaction } from '../models/payment.model';
import { ApiService } from './api.service';

export interface RejectedItemsErrorResponse {
  items: RejectedItem[];
  modifiers: RejectedItem[];
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private lastOrder: GetOrder;
  private lastTransaction: Transaction;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private dataService: DataService,
    private splashScreenService: SplashScreenService
  ) { }
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  public async submitOrder(tableId: string, order: Order): Promise<any> {
    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
      this.apiService.orderItems(tableId, order)
        .subscribe({
          next: (orderResponse) => resolve({ order: orderResponse }),
          error: (error) => {
            if (error.status === 403) {
              const menuClosed: MenuClosedResponse = error.error;
              this.splashScreenService.updateSplashStatus('menuClosed', menuClosed.image, menuClosed.languages);
              // Resolve so callers can stop loaders and dismiss the cart /
              // payment overlays that would otherwise hide the closed screen.
              resolve({menuClosed: true, error: error.error});
            } else {
              resolve({ error: error.error })
            }
          }
        });
    });
  }

  public setLastOrder(order?: GetOrder): void {
    const lastOrder$: Observable<GetOrder> = order ? of(order) : this.fetchLatestOrder();

    lastOrder$.subscribe(lastOrder => {
      this.lastOrder = lastOrder;
      this.router.navigate(['/confirm-order']);
    });
  }

  private fetchLatestOrder(): Observable<GetOrder> {
    const userId: string = this.dataService.getUserId();
    const restaurantId: string = this.dataService.restaurant().id;
    return this.apiService.getOrders(userId, restaurantId).pipe(
      map(orders => orders.orders[0])
    );
  }

  public getLastOrder(): GetOrder {
    return this.lastOrder;
  }

  public setLastTransaction(transaction_id: string): Observable<Transaction> {
    return this.apiService.getTransaction(transaction_id).pipe(
      tap(tx => this.lastTransaction = tx),
      shareReplay(1) // cache last emission
    );
  }

  public getLastTransaction(): Transaction {
    return this.lastTransaction;
  }

}
